import { RegExpUtility } from "../../../text/RegExpUtility";
import { ConstantExpressionFactory } from "../../expressions/ConstantExpressionFactory";
import { RJExpressionNode } from "../../expressions/RJExpressionNode";
import { ConstantOperator } from "../../operators/ConstantOperator";
import { BinaryOperator } from "../../operators/BinaryOperator";
import { RJOperatorsProcessor } from "../../phases/RJOperatorsProcessor";
import { RJParser } from "../../RJParser";
import { LomaConstantExpressionFactory } from "./LomaConstantExpressionFactory";
import { LexerMatcherLibrary } from "../../../text/lexer/LexerMatcherLibrary";
import { GroupOperator } from "../../operators/GroupOperator";
import { UnaryOperator } from "../../operators/UnaryOperator";
import { RJParserMessages } from "../RJParserMessages";
import { SourceInfo, SourceRange } from "../../../text/lexer/parsing/SourceInfo";
import { SequenceOperator } from "../../operators/SequenceOperator";
import { FunctionOperator } from "../../operators/FunctionOperator";
import { VariableOperator } from "../../operators/VariableOperator";

export class LomaOperatorProcessor extends RJOperatorsProcessor
{
  static readonly phaseInfo = "Loma Operator Processor";
  get phaseInfo(){ return LomaOperatorProcessor.phaseInfo; }

  parsedExpressions:RJExpressionNode[];

  constantOperator:ConstantOperator;
  groupOperator:GroupOperator;
  functionOperator:FunctionOperator;
  variableOperator:VariableOperator;

  unaryPlus:UnaryOperator;
  unaryMinus:UnaryOperator;

  plus:BinaryOperator;
  multiply:BinaryOperator;
  minus:BinaryOperator;
  division:BinaryOperator;
  modulo:BinaryOperator;


  power:BinaryOperator;

  sequenceOperator:SequenceOperator;

  constructor( parser:RJParser )
  {
    super( parser );

    this.constantOperator = new ConstantOperator( this.parser, 
      LomaConstantExpressionFactory.constantTypeMatcher, new LomaConstantExpressionFactory() );
    
    this.groupOperator = new GroupOperator( this.parser, [ "(", ")" ] );

    this.functionOperator = new FunctionOperator( this.parser );

    this.variableOperator = new VariableOperator( this.parser );

    this.unaryPlus  = new UnaryOperator( this.parser, "+", true, false, true );
    this.unaryMinus = new UnaryOperator( this.parser, "-", true, false, true );

    this.plus       = new BinaryOperator( this.parser, "+" );
    this.multiply   = new BinaryOperator( this.parser, "*" );
    this.minus      = new BinaryOperator( this.parser, "-" );
    this.division   = new BinaryOperator( this.parser, "/" );

    this.modulo   = new BinaryOperator( this.parser, "%" );

    this.power      = new BinaryOperator( this.parser, "^", false  );

    this.sequenceOperator = new SequenceOperator( this.parser, "," );

    this._createLevels();
  }

  _createLevels()
  {
    this.addPrecedenceLevel( this.constantOperator );


    this.addPrecedenceLevel( this.groupOperator );

    this.addPrecedenceLevel( this.functionOperator );

    this.addPrecedenceLevel( this.variableOperator );

    
    this.addPrecedenceLevel( this.power );

    this.addPrecedenceLevel( this.unaryPlus, this.unaryMinus );

    this.addPrecedenceLevel( this.multiply, this.division, this.modulo );

    this.addPrecedenceLevel( this.plus, this.minus );



    this.addPrecedenceLevel( this.sequenceOperator );
  }


  process()
  {
    let whiteSpaceOrBreak = RegExpUtility.createMatcherFromCombiningWords(
      [
        LexerMatcherLibrary.WHITESPACE_MATCHER.type,
        LexerMatcherLibrary.BREAK_MATCHER.type,
      ], true
    );

    let tokens = this.parser.createTokens.tokens;
    let filteredTokens = tokens.filter( t => ! t.isToken( whiteSpaceOrBreak )  );  

    this.parsedExpressions = filteredTokens.map( t => t.cloneNode() );
    this.processExpressions( this.parsedExpressions );

    if ( this.parsedExpressions.length > 1 )
    {
      let sourceRange = SourceRange.combine( this.parsedExpressions[ 0 ].sourceRange, this.parsedExpressions[ this.parsedExpressions.length -1 ].sourceRange );
      let sourceInfo = SourceInfo.fromRange( sourceRange );

      this.parser.error( RJParserMessages.expressionCouldNotBeResolved, sourceInfo );
    }

  }
}